export default __webpack_public_path__ + "static/media/ydrd.b54996bc.jpg";